import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SUPPORTER_TO_STARTER_RECOMMENDATIONS_CONFIG = createFcmDetails(
	'supporter_to_starter_recommendations_config',
	{
		owner: 'starfish',
		context: 'Start a Recommended Petition Flow in PSF',
		description: 'AI Prompt config for the supporter to starter recommendations experience.',
		import: false,
		template: {
			systemPrompt: 'A system prompt to generate related petition topics',
			prompt: [
				{
					replacer: 'ask',
					text: 'Replace this text: %{ask}',
				},
				{
					replacer: 'description',
					text: 'Replace this text: %{description}',
				},
				{
					replacer: 'location',
					text: 'Replace this text: %{location}',
				},
			],
			options: {
				model: 'gpt-4o',
			},
		},
	},
);
